export default {"src":"/_next/static/media/logo-fonts-light-v2.54fcd17c.svg","height":23,"width":120,"blurWidth":0,"blurHeight":0};